import { useState } from 'react'
import type { ProviderManagement } from '../types'
import { useClearStaleSelection } from './useClearStaleSelection'

interface DeleteFormState {
  provider: ProviderManagement | null
  includeCollections: boolean
  includeNotifications: boolean
  includeSavedSearch: boolean
}

const initial: DeleteFormState = {
  provider: null,
  includeCollections: false,
  includeNotifications: false,
  includeSavedSearch: false,
}

export const useDeleteForm = (filteredOptions: ProviderManagement[]) => {
  const [form, setForm] = useState<DeleteFormState>(initial)

  const update = (patch: Partial<DeleteFormState>) =>
    setForm((prev) => ({ ...prev, ...patch }))

  const reset = () => setForm(initial)

  useClearStaleSelection(form.provider, filteredOptions, () =>
    update({ provider: null }),
  )

  return { form, update, reset }
}
